import { Zap } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const AutoEnableIcon = DeckardIconWrapper({ Icon: Zap });
